// extracted by mini-css-extract-plugin
export default {"sort":"SortTitle_sort__+pjg2","sort__title":"SortTitle_sort__title__RkMn4","sort__icons":"SortTitle_sort__icons__haVT3"};